import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      TITLE: "Betalingsoversikt",
      PAYMENT_METHOD: "Betalingsmetode",
      CHANGE_BUTTON_TEXT: "Endre",
      PAYMENT_CARD: "Bankkort",
      EXPIRATION_DATE: "Utløpsdato (MM/ÅÅ)",
      PAYMENT_HISTORY: "Ordrehistorikk",
      DATE: "Dato",
      AMOUNT: "Beløp",
      STATUS: "Status",
      PAID: "Betalt",
      UNPAID: "Ikke betalt",
      CURRENCY_UNIT: "kr",
      VIEW_INVOICE: "Se faktura",
      VIEW_RECEIPT: "Se kvittering",
      RECEIPT: "Kvittering",
      LOAD_MORE_BUTTON_TEXT: "Vis mer",
      NO_ORDERS: "Ingen betalingshistorikk å vise.",
      LOADING_ORDERS: "Laster betalingshistorikk...",
      YOURE_PAYING_WITH: "Du betaler med",
      INVOICE: "faktura",
      UNKNOWN: "Ukjent",
      THIS_ORDER_HAS_UNKNOWN_PAYMENT_STATUS:
        "Denne ordren har ukjent status. Dette kan skyldes systemfeil. Ta kontakt med kundeservice.",
      SENT_TO_DEBT_COLLECTION: "Inkasso",
      THIS_PAYMENT_IS_IN_DEBT_COLLECTION:
        "Denne betalingen er overført til inkasso, og faktura må betales direkte til inkassoselskapet. Ta kontakt med kundeservice for mer informasjon.",
      CONTACT_CUSTOMER_SERVICE_FOR_INVOICE: "Kontakt kundeservice for faktura",
      CREATING_PAYMENT_SESSION:
        "Gjør klart betalingssiden. Du blir snart omdirigert...",
    },
    se: {
      TITLE: "Betalningsöversikt",
      PAYMENT_METHOD: "Betalningsöversikt",
      CHANGE_BUTTON_TEXT: "Ändra",
      PAYMENT_CARD: "Betalkort",
      EXPIRATION_DATE: "Utgår (MM/ÅÅ)",
      PAYMENT_HISTORY: "Betalningshistorik",
      DATE: "Datum",
      AMOUNT: "Belopp",
      STATUS: "Status",
      PAID: "Betald",
      UNPAID: "Obetald",
      CURRENCY_UNIT: "kr",
      VIEW_INVOICE: "Visa faktura",
      VIEW_RECEIPT: "Visa kvitto",
      RECEIPT: "Kvitto",
      LOAD_MORE_BUTTON_TEXT: "Visa mer",
      NO_ORDERS: "Ingen betalningshistorik att visa.",
      LOADING_ORDERS: "Laddar betalningshistorik...",
      YOURE_PAYING_WITH: "Du betalar med",
      INVOICE: "faktura",
      UNKNOWN: "Okänd",
      THIS_ORDER_HAS_UNKNOWN_PAYMENT_STATUS:
        "Denna order har okänd status. Detta kan bero på systemfel. Kontakta kundtjänst.",
      SENT_TO_DEBT_COLLECTION: "Inkasso",
      THIS_PAYMENT_IS_IN_DEBT_COLLECTION:
        "Denna betalning har överförts till inkasso och fakturan måste betalas direkt till inkassobolaget. Kontakta kundtjänst för mer information.",
      CONTACT_CUSTOMER_SERVICE_FOR_INVOICE: "Kontakta kundtjänst för faktura",
      CREATING_PAYMENT_SESSION:
        "Förbereder betalningssidan. Du kommer snart att omdirigeras...",
    },
    dk: {
      TITLE: "Betalingsmetode",
      PAYMENT_METHOD: "Dit betalingskort",
      CHANGE_BUTTON_TEXT: "Skift",
      PAYMENT_CARD: "Betalingskort",
      EXPIRATION_DATE: "Udløber (MM/ÅÅ)",
      PAYMENT_HISTORY: "Kontoudtog",
      DATE: "Dato",
      AMOUNT: "Beløb",
      STATUS: "Status",
      PAID: "Betalt",
      UNPAID: "Ikke betalt",
      CURRENCY_UNIT: "kr.",
      VIEW_INVOICE: "Se faktura",
      VIEW_RECEIPT: "Se kvittering",
      RECEIPT: "Kvittering",
      LOAD_MORE_BUTTON_TEXT: "Indlæs mere",
      NO_ORDERS: "Ingen betalingshistorik at vise.",
      LOADING_ORDERS: "Indlæser betalingshistorik...",
      YOURE_PAYING_WITH: "Du betaler med",
      INVOICE: "faktura",
      UNKNOWN: "Ukendt",
      THIS_ORDER_HAS_UNKNOWN_PAYMENT_STATUS:
        "Denne ordre har ukendt status. Dette kan skyldes systemfejl. Kontakt venligst kundeservice.",
      SENT_TO_DEBT_COLLECTION: "Inkasso",
      THIS_PAYMENT_IS_IN_DEBT_COLLECTION:
        "Denne betaling er overført til inkasso, og fakturaen skal betales direkte til inkassoselskabet. Kontakt venligst kundeservice for mere information.",
      CONTACT_CUSTOMER_SERVICE_FOR_INVOICE: "Kontakt kundeservice for faktura",
      CREATING_PAYMENT_SESSION:
        "Forbereder betalingssiden. Du vil snart blive omdirigeret...",
    },
  } as const
)[language];
